<template>
  <span
    v-translate:_formattedBody="{
      key: translationKeyInitial,
      val: lang,
      optionId: option.id,
      html: formattedBody,
      optionLable
    }"
    v-html="formattedBody"
  ></span>
</template>

<script>
export default {
  name: "multi-choice-translated-option",
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    lang: {
      type: String,
      default: ""
    },
    translationKeyInitial: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      optionLable: "_options_"
    };
  },
  computed: {
    formattedBody() {
      return this.option.formattedBody || "";
    }
  }
};
</script>
